import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { createClient } from '@supabase/supabase-js'
import Login from './pages/Login'
import AdminDashboard from './pages/AdminDashboard'
import StoreDashboard from './pages/StoreDashboard'

const supabase = createClient(
  'https://pyfdklhdpihfbicitesu.supabase.co',
  'sb_publishable_lFdCcbt9F3UvYL-1TC4hvw_aFTudP8j'
)

export { supabase }

function App() {
  const [session, setSession] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      setLoading(false)
    })
    supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
    })
  }, [])

  if (loading) return <div style={{padding: '2rem'}}>Loading...</div>

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!session ? <Login supabase={supabase} /> : <Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={session ? <AdminDashboard supabase={supabase} session={session} /> : <Navigate to="/login" />} />
        <Route path="/store" element={session ? <StoreDashboard supabase={supabase} session={session} /> : <Navigate to="/login" />} />
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App